<template>
  <button
    type="button"
    class="inline-flex items-center rounded-sm border border-gray-300 bg-white text-xs font-medium text-gray-700 shadow-sm hover:bg-gray-100 hover:text-gray-700 p-2 pl-2.5 focus:ring-0 focus:outline-0 focus:ring-offset-0 disabled:opacity-50"
    @click="click"
    :disabled="props.disabled"
  >
    <component
      :is="props.icon"
      class="-ml-1 mr-1.5 h-4 w-4 text-gray-500"
      aria-hidden="true"
      v-if="props.icon"
    />
    {{ props.label }}
  </button>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";

const props = defineProps({
  label: String,
  icon: Object,
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(["click"]);
const click = () => emit("click");
</script>
